import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["successField", "workplaceCheckbox", "existingCheckbox", "submitButton"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const successFilled = this.successFieldTarget.value.trim().length > 0
    const workplaceSelected = this.workplaceCheckboxTargets.some((checkbox) => checkbox.checked)
    const existingSelected = this.existingCheckboxTargets.some((checkbox) => checkbox.checked)

    this.submitButtonTarget.disabled = !(successFilled && workplaceSelected && existingSelected)
  }
}
